import styled from "styled-components";

export const Footer = styled.div`
background-color: rgba(20, 26, 32, 1);
color: rgba(255, 255, 255, 1);
font-size: 0.7rem;
padding: 2.5rem 0;
`

export const FooterBody = styled.div`
display: flex;
flex-wrap: wrap;
column-gap: 1.5rem;
justify-content: space-between;
`

export const FooterTitle = styled.div`
margin-bottom: 1rem;
text-transform: uppercase;
`
export const FooterCompany = styled.div`
max-width: 15rem;
`


export const FooterLinkItems = styled.div`
display:flex;
column-gap: 1.5rem;
`

export const FooterLinkItem = styled.div`
margin-bottom: 0.6rem;
text-transform: uppercase;
letter-spacing: 0.06rem;
`

export const FooterLinkIcon = styled.div`
display: flex;
padding-top: 1.7rem;
`

export const FooterLinkIconItem = styled.div`
margin-right: 1.5rem;
font-size: 0.82rem;
`